import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import '../../styles/AdminNavigation.css';

interface AdminNavigationProps {
  currentSection: string;
  showBackButton: boolean;
  onBack: () => void;
}

/**
 * AdminNavigation component - Provides navigation bar for admin sections
 */
const AdminNavigation: React.FC<AdminNavigationProps> = ({ 
  currentSection, 
  showBackButton, 
  onBack 
}) => {
  return (
    <div className="admin-navigation">
      {showBackButton && (
        <button 
          className="admin-nav-back"
          onClick={onBack}
        >
          <FontAwesomeIcon icon={faArrowLeft} /> Back to Dashboard
        </button>
      )}
      <div className="admin-section-title">
        {currentSection}
      </div>
    </div>
  );
};

export default AdminNavigation;
